import helperFunctions from "./helper-functions";
import meetingModel from "@/store/orm-axios/models/Meeting";
let eventSource;

const meetingIRI = "/meetings/";

export default {
  computed: {
    mercureJwtToken() {
      return this.$store.getters["auth/mercureJwtToken"];
    },
  },
  watch: {
    mercureJwtToken(oldValue, newValue) {
      if (oldValue.length != 0 && newValue.length != 0) {
        this.initMeetingMercure();
      }
    },
  },
  mounted() {
    this.initMeetingMercure();
  },
  beforeDestroy() {
    eventSource.close();
  },
  methods: {
    initMeetingMercure() {
      if (eventSource) eventSource.close();

      const topics = [`${meetingIRI}{id}`];

      eventSource = helperFunctions.getEventSource(topics);

      eventSource.onmessage = event => {
        const eventData = JSON.parse(event.data);

        var model = null;
        if (eventData["@id"].includes(meetingIRI)) {
          model = meetingModel;
        }

        helperFunctions.modifyInStore(eventData, model);
      };

      helperFunctions.case401Error(eventSource);
    },
  },
};
